export enum ScaleMode { // ScaleMode.cs
    Default = 0,
    Max,
    Pad,
    Crop,
    Carve,
    Stretch
}